var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#3D5AFE",
    d: "M17.37 6.73c.9 0 1.63.73 1.63 1.63v3.26c0 .9-.73 1.63-1.63 1.63h-.87a6.532 6.532 0 01-6.48 5.71v-1.63c2.7 0 4.89-2.19 4.89-4.89V7.55c0-3.77-4.08-6.12-7.34-4.24a4.901 4.901 0 00-2.45 4.24v5.71H2.69c-.9 0-1.63-.73-1.63-1.63V8.37c0-.9.73-1.63 1.63-1.63h.87c.62-4.99 6.41-7.43 10.41-4.39a6.517 6.517 0 012.53 4.38h.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D5AFE",
    fill: "#fff",
    d: "M6.57 13.08l.86-1.38a4.905 4.905 0 005.18 0l.86 1.38c-1.04.65-2.24.99-3.46.99-1.22 0-2.42-.34-3.46-.99z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon_support.5c17322d1a65d9d2302c2caf1581b233.svg";
export { ForwardRef as ReactComponent };